export default {
	getSettings: {
		body: undefined,
		query: undefined,
		params: undefined,
	},
};
